<template>
  <vx-card no-shadow>

    <div class="vx-col">
    <div class="w-full flex flex-wrap item-center mb-base mt-2">
      <h5> 정말 </h5> <h3 class="text-danger">탈퇴</h3> <h5> 하실건가요? :( </h5> &nbsp;&nbsp; <br>
      <p class="text-danger"> 관리되고 있던 프로젝트와 클래스을 더이상 확인할 수 없어요.</p>
    </div>
  </div>

    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="activeUserInfo.photoURL" size="70px" class="mr-4 mb-4" />
    </div>
    <vs-input disabled class="w-full mb-base" label="이름" placeholder="이름" v-model="username"></vs-input>
    <!-- <vs-input class="w-full mb-base" label-placeholder="Name" v-model="name"></vs-input> -->
    <vs-input disabled class="w-full my-4" label="이메일" placeholder="예) user01@filledyou.com" v-model="email"></vs-input>

    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="openConfirm()" style="margin:3px" type="filled" color="danger">회원탈퇴</vs-button>
    </div>

  </vx-card>

</template>

<script>
// import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data() {
    return {
      // username: "johny_01",
      username: this.$store.state.AppActiveUser.displayName,
      email: this.$store.state.AppActiveUser.email,
      // company: "SnowMash Technologies Pvt Ltd",
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
  },
  methods:{
    openConfirm(){
    this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `회원탈퇴`,
        text: '정말 탈퇴하시겠습니까? 모든 클래스과 프로젝트가 삭제됩니다.',
        accept: this.logout
      })
    },
    logout() {
      this.$store.dispatch('auth/deleteUser')
      localStorage.removeItem("accessToken")
      localStorage.removeItem('userInfo')
      this.$router.push('/pages/intro')
    },
  }
 }
</script>
